import Image from 'next/image';

export default function VideoCard({ thumbnailUrl, href, title }) {
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className="group">
      <div className="relative">
        <div
          aria-hidden="true"
          className="bg-rose opacity-0 group-hover:opacity-[0.12] absolute inset-0 transition-all"
        />

        <Image
          src={thumbnailUrl}
          alt={`${title} thumbnail`}
          width={320}
          height={180}
          className="object-contain rounded-lg"
        />

        <div className="absolute bottom-3 right-3 w-8 h-8 rounded-full bg-rose flex items-center justify-center">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.3402 7.42663L4.34016 2.75995C3.8935 2.49995 3.3335 2.81995 3.3335 3.33328V12.6666C3.3335 13.18 3.8935 13.5 4.3335 13.24L12.3335 8.57329C12.7802 8.31996 12.7802 7.67996 12.3402 7.42663Z"
              fill="white"
            />
          </svg>
        </div>
      </div>

      <p className="text-white font-bold text-lg leading-[22px] pt-6">
        {title}
      </p>
    </a>
  );
}
